import React from 'react';
import PropTypes from 'prop-types';

import DocumentActionsMenu, { DOCUMENT_ACTIONS_MENU_VARIANTS } from './DocumentActionsMenu';

const DocumentHistoryRowMenu = ({
  document,
  onRequestDelete,
  onSelectFormStatus,
  onSelectFormValidity,
  onSelectSetExpiration,
}) => (
  <DocumentActionsMenu
    document={document}
    onRequestDelete={onRequestDelete}
    onSelectFormStatus={onSelectFormStatus}
    onSelectFormValidity={onSelectFormValidity}
    onSelectSetExpiration={onSelectSetExpiration}
    variant={DOCUMENT_ACTIONS_MENU_VARIANTS.HISTORY}
  />
);

DocumentHistoryRowMenu.propTypes = {
  document: PropTypes.shape({
    _id: PropTypes.string,
    state: PropTypes.shape({ status: PropTypes.string }),
    validity: PropTypes.shape({
      status: PropTypes.string,
      range: PropTypes.shape({
        validFrom: PropTypes.string,
        validNoticeFrom: PropTypes.string,
        validThrough: PropTypes.string,
      }),
    }),
  }).isRequired,
  onRequestDelete: PropTypes.func,
  onSelectFormStatus: PropTypes.func,
  onSelectFormValidity: PropTypes.func,
  onSelectSetExpiration: PropTypes.func,
};

DocumentHistoryRowMenu.defaultProps = {
  onRequestDelete: () => {},
  onSelectFormStatus: () => {},
  onSelectFormValidity: () => {},
  onSelectSetExpiration: () => {},
};

export default DocumentHistoryRowMenu;
